export default "__VITE_ASSET__jM7JRM5v__"